import React, { memo } from 'react'

import { SectionTabs, Panel } from './Subtabs'
import Admin from './Admin'
import Config from './Config'
import BudgetTab from './BudgetTab'
import EventorPersons from './EventorPersons'
import { useHasCapability } from './Capabilities'

// The two admin areas under one tab, each sub-tab shown only if the role holds its capability
// (mirrors EventorSyncTab). Role management and company config are both admin-gated, so they
// share a home; the parent tab appears if the role holds either capability.
// memo (no props) so it renders once and isn't reconciled on every unrelated tab switch — its role
// editor + config cards are heavy.
const SettingsTab = memo(function SettingsTab() {
    const canRoles = useHasCapability('admin.roles')
    const canCompanyConfig = useHasCapability('admin.company_config')
    const canBudget = useHasCapability('config.budget')
    const canEventorPersons = useHasCapability('admin.eventor_persons')

    const subtabs: Panel[] = []
    if (canRoles) subtabs.push({ slug: 'roller', label: 'Roller & behörigheter', panel: () => <Admin/> })
    if (canCompanyConfig) subtabs.push({ slug: 'foretag', label: 'Företag', panel: () => <Config/> })
    // Its own sub-tab rather than another card under Företag: it is a yearly task with its own
    // year picker, and it is gated on its own capability, so it can be granted without granting
    // the rest of the company configuration.
    if (canBudget) subtabs.push({ slug: 'budget', label: 'Budget', panel: () => <BudgetTab/> })
    // Its own sub-tab, and its own capability: connecting a user to an Eventor person decides
    // whose Eventor session Eko may hand out, which is a narrower and sharper grant than the
    // rest of the role editor.
    if (canEventorPersons) subtabs.push({ slug: 'eventor-personer', label: 'Eventor-personer',
                                          panel: () => <EventorPersons/> })

    return <SectionTabs panels={subtabs}/>
})

export default SettingsTab
